import { render, staticRenderFns } from "./review-form.vue?vue&type=template&id=6bea0ac5"
import script from "./review-form.vue?vue&type=script&lang=js"
export * from "./review-form.vue?vue&type=script&lang=js"
import style0 from "./review-form.vue?vue&type=style&index=0&id=6bea0ac5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports